var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirstQuarterMoonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 50,
    viewBox: "0 0 25 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.49466e-05 47.4686L6.10514e-05 2.53144C-0.00249978 2.17441 0.07044 1.82093 0.214024 1.49453C0.357608 1.16814 0.56854 0.876325 0.832771 0.638531C1.097 0.400736 1.40847 0.222423 1.74642 0.115455C2.08438 0.00848761 2.44107 -0.0246811 2.79274 0.018173C8.89673 0.695192 14.5382 3.61876 18.6361 8.22862C22.7339 12.8385 25 18.8104 25 25C25 31.1896 22.7339 37.1615 18.6361 41.7714C14.5382 46.3813 8.89673 49.3048 2.79274 49.9818C2.44108 50.0247 2.08439 49.9915 1.74643 49.8846C1.40847 49.7776 1.09701 49.5993 0.832776 49.3615C0.568544 49.1237 0.357612 48.8319 0.214028 48.5055C0.070444 48.1791 -0.00249583 47.8256 6.49466e-05 47.4686Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstQuarterMoonIcon);
export default __webpack_public_path__ + "static/media/FirstQuarterMoonIcon.580bc1eb72e12768be03886170c40555.svg";
export { ForwardRef as ReactComponent };